import React, { useEffect, useState } from "react";
import { HashRouter, Switch, Route, Redirect } from "react-router-dom";
import { useQlik } from "../context/Qlik";
import { useFilterBar } from "../context/FilterBar";
import { useLeftBar } from "../context/LeftBar";
import { useConfig } from "../context/Config";
import Overview from "./Overview/Overview";
import LeftSideMenu from "../components/LeftSideMenu/LeftSideMenu";
import AppLoader from "../components/AppLoader/AppLoader";
import FilterMenu from "../components/FilterMenuNative/FilterMenu";
import Header from "../components/Header/Header";
import "../style.scss";
import Regional from "./Regional/Regional";
import Categorias from "./Categorias/Categorias";
import Qualificada from "./Qualificada/Qualificada";
import Cliente  from "./Cliente/Cliente";
import MapaMina from "./MapaMina/MapaMina";

function Layout() {
  const { qlik, qlikConfig, setActualApp } = useQlik();
  const { filterBarOpened } = useFilterBar();
  const { leftBarOpened } = useLeftBar();
  const { config } = useConfig();
  const [app, setApp] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (qlik) {
      setIsLoading(false);
      const qvfId = process.env.REACT_APP_QVF_ID;
      const tempApp = qlik.openApp(qvfId, qlikConfig);
      window.app = tempApp;
      setApp(tempApp);
      setActualApp(tempApp);
    }
  }, [qlik, qlikConfig, setActualApp]);

  useEffect(() => {
    if (qlik) setTimeout(qlik.resize, 500);
  }, [qlik]);

  return isLoading ? (
    <AppLoader />
  ) : (
    <div
      className={filterBarOpened ? "appWrapper is-right-opened" : "appWrapper"}
    >
      <div id="expandedWrapper" />
      <HashRouter>
        <Header />
        <FilterMenu
          app={app}
          filters={config?.app?.filters || {}}
          config={config}
        />
        <div className="container-app">
          <LeftSideMenu app={app} config={config} />

          <Switch>
            <Route exact path="/">
              <Redirect to="/overview" />
            </Route>
            <Route
              path="/overview"
              exact
              render={() => <Overview app={app} config={config} />}
            />
            <Route
              path="/regional"
              exact
              render={() => (
                <Regional app={app} config={config} />
              )}
            />

            <Route
              path="/categorias"
              exact
              render={() => (
                <Categorias app={app} config={config} />
              )}
            />

            <Route
              path="/qualificada"
              exact
              render={() => <Qualificada app={app} config={config} />}
            />

            <Route
              path="/cliente"
              exact
              render={() => <Cliente app={app} config={config} />}
            />
            <Route
              path="/mapa-da-mina"
              exact
              render={() => <MapaMina app={app} config={config} />}
            />
          </Switch>
        </div>
      </HashRouter>
    </div>
  );
}

export default Layout;
